import { render } from "./OrderersList.vue?vue&type=template&id=497a376c&scoped=true"
import script from "./OrderersList.vue?vue&type=script&lang=js"
export * from "./OrderersList.vue?vue&type=script&lang=js"

import "./OrderersList.vue?vue&type=style&index=0&id=497a376c&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-497a376c"]])

export default __exports__